// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"250":"cb1645d7","453":"3154de31","915":"576d2c29"}[chunkId] + ".chunk.js";
};